export default __webpack_public_path__ + "static/media/news-inner-image-left.9ec622a5.jpg";